import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { apiPaths } from './apiPaths';

const baseQuery = fetchBaseQuery({
    baseUrl: apiPaths.vivaBaseUrl(),
    // credentials: 'include',
    // prepareHeaders: (headers) => setHeaders(headers),
});

export const vivaApi = createApi({
    reducerPath: 'vivaApi',
    baseQuery: baseQuery,
    endpoints: () => ({}),
    tagTypes: ['CollectionMetadata'],
});

export default vivaApi;
